var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRelatedToIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.715,
    height: 18.573,
    viewBox: "0 0 16.715 18.573",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-assignment-ind",
    "data-name": "Icon material-assignment-ind",
    d: "M19.358,3.357H15.476a2.775,2.775,0,0,0-5.238,0H6.357A1.863,1.863,0,0,0,4.5,5.215v13a1.863,1.863,0,0,0,1.857,1.857h13a1.863,1.863,0,0,0,1.857-1.857v-13A1.863,1.863,0,0,0,19.358,3.357Zm-6.5,0a.929.929,0,1,1-.929.929A.931.931,0,0,1,12.858,3.357Zm0,3.715a2.786,2.786,0,1,1-2.786,2.786A2.782,2.782,0,0,1,12.858,7.072ZM18.43,18.215H7.286v-1.3c0-1.857,3.715-2.879,5.572-2.879s5.572,1.021,5.572,2.879Z",
    transform: "translate(-4.5 -1.5)",
    fill: "#7e7e7e"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRelatedToIcon);
export default __webpack_public_path__ + "static/media/related-to-icon.034c491dc01e54ac3b1104a4d4d48980.svg";
export { ForwardRef as ReactComponent };